import { ConstrainedString } from '../generic'
import { PollId } from '../Poll'
import { Timestamp } from '../Timestamp'

export type BallotId = ConstrainedString<'ballot-id'>

export enum VoteMethod {
  Automatic = 'automatic',
  Manual = 'manual',
}

export interface Ballot {
  id: BallotId
  pollId: PollId
  createTime: Timestamp
  expirationTime: Timestamp
  investorVote?: {
    response: InvestorVoteResponse
    responseTime: Timestamp
    voteMethod: VoteMethod
  }
  comment?: BallotComment
}

export interface BallotComment {
  content: string
  createTime: Timestamp
}

export type InvestorVoteResponse = 'for' | 'against' | 'abstain' | 'withhold' | 'no_action'

export const mapInvestorVoteResponseText = (response: InvestorVoteResponse): string => {
  return {
    ['for' as InvestorVoteResponse]: 'In favour',
    ['against' as InvestorVoteResponse]: 'Against',
    ['abstain' as InvestorVoteResponse]: 'To abstain',
    ['withhold' as InvestorVoteResponse]: 'Withhold',
    ['no_action' as InvestorVoteResponse]: 'No action',
  }[response]
}
